<template>
  <div v-if="links.length > 3">
    <div class="pagination py-4">
      <template v-for="(link, key) in links">
        <li v-if="link.url === null" :key="key" class="page-item disabled">
          <Link class="page-link" href="javascript:void(0)" v-html="link.label" />
        </li>
        <li v-else :key="`link-${key}`" class="page-item" :class="{ 'active': link.active }">
          <Link class="page-link" :href="link.url" v-html="link.label" />
        </li>
      </template>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
  },
  props: {
    links: Array,
  },
}
</script>